import { Region } from '@medusajs/medusa'

import { RegionRepository } from '../repositories/regions'

type InjectedDependencies = {
    regionRepository: RegionRepository
}

export class RegionService {
    private readonly regionRepository: RegionRepository

    constructor({ regionRepository }: InjectedDependencies) {
        this.regionRepository = regionRepository
    }

    public async listRegions(): Promise<Region[]> {
        return this.regionRepository.listRegions()
    }
}
